import { iProfile } from "../presentation/interfaces/profile.interface";
import { createApiError, normalizeToApiError } from "./error.service";
import { interceptorFetch } from "./interceptor.service";


export async function getProfile(employeeId: number, token: string, updateToken: (newToken: string) => void): Promise<iProfile> {
    try {
        const response = await interceptorFetch(`employee/${employeeId}`, token!, updateToken, {
            method: "GET"
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Invalid error response' }));
            throw createApiError(errorData, response.status);
        }

        return await response.json();

    } catch (error: unknown) {
        throw normalizeToApiError(error);
    }
}

const prepareUpdatedProfile = (profile: iProfile) => {
    const preparedProfile = {
        firstName: profile.firstName,
        lastName: profile.lastName,
        birthDate: profile.birthDate,
        nationality: profile.nationality,
        state: profile.state,
        city: profile.city,
        phone: profile.phone,
        address: profile.address,
    }
    return preparedProfile;
};


export async function update(employeeId: number, updatedProfile: iProfile, token: string, updateToken: (newToken: string) => void): Promise<iProfile | null> {
    try {
        const filteredProfile = await prepareUpdatedProfile(updatedProfile);
        const response = await interceptorFetch(`employee/${employeeId}`, token, updateToken, {
            method: "PATCH",
            body: JSON.stringify(filteredProfile),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: `Error updating employee: ${response.status}` }));
            throw createApiError(errorData, response.status);
        }

        const data = await response.json();

        return data;
    } catch (error: unknown) {
        throw normalizeToApiError(error);
    }
}
